import React from 'react'

import { INSIDE_DIALOG_CSS_VARIABLE } from '@constants'

/**
 * Helper function to check if we're inside a dialog using CSS custom properties
 * @param referenceElement - The element to check if it's inside a dialog
 * @returns True if the element is inside a dialog, false otherwise
 */
export function useIsInsideDialog(referenceElement: Element | null): boolean {
  const [isInsideDialog, setIsInsideDialog] = React.useState(false)

  React.useEffect(() => {
    if (!referenceElement) {
      setIsInsideDialog(false)
      return
    }

    const computedStyle = getComputedStyle(referenceElement)
    const isInDialog =
      computedStyle.getPropertyValue(INSIDE_DIALOG_CSS_VARIABLE.key).trim() === INSIDE_DIALOG_CSS_VARIABLE.value
    setIsInsideDialog(isInDialog)
  }, [referenceElement])

  return isInsideDialog
}
